angular.module('rjmNg.directives').directive "googleAnalyticsReportingProfilePicker", [
  () ->
    bindToController: true
    controllerAs: "view"
    require: "^?rjmUi"
    restrict: "E"
    scope:
      cancelCallback: "&"
      connection: "="
      successCallback: "&"
      profileId: "="
    templateUrl: "directive.googleAnalyticsReportingProfilePicker.html"
    controller: [
      "InputConnections"
      "app"
      "notification"
      (
        InputConnections
        app
        notification
      ) ->

        view = @
        view.loading = false

        view.profiles = null

        InputConnectionsInstance = InputConnections(app.getClientId())

        view.NOTIFICATION_SCOPE = "global"
        notification.clear(view.NOTIFICATION_SCOPE)

        view.invalidProfilesHidden = false

        ERROR_MESSAGES =
          NO_DATA: "None of the Google Analytics profiles associated with the
            credentials you've supplied contain data that Adobe Commerce Intelligence can access.
            Please make sure that the credentials you've supplied have
            appropriate access."
          PROFILES: "An error occurred fetching a list of Google Analytics
            profiles with data to track."

        showError = (message) ->
          view.loading = false
          notification.clear()
          notification.error("Something went wrong.", message, view.NOTIFICATION_SCOPE)

        view.changeSelectedProfile = ({id}) ->
          view.profileId = id

        view.cancel = () ->
          view.cancelCallback()

        view.selectProfile = () ->
          view.connection.properties.view_id = view.profileId
          view.successCallback()

        init = () ->
          view.loading = true
          InputConnectionsInstance.getProfiles(view.connection.id, view.connection.type)
          .then (allProfiles) ->
            profiles = allProfiles.filter (profile) ->
              profile.saw_data and profile.has_access

            invalidProfilesHidden = profiles.length < allProfiles.length

            if profiles.length > 0
              view.profiles = profiles

              # If the profile isn't set, set it to the first profile.
              unless view.profileId?
                firstProfile = profiles[0]
                view.profileId = firstProfile.id

              notification.clear(view.NOTIFICATION_SCOPE)
              if invalidProfilesHidden
                notification.warning("Some profiles were hidden.", "Some profiles were hidden.", view.NOTIFICATION_SCOPE, {}, true)

            else
              showError ERROR_MESSAGES.NO_DATA
          .catch () ->
            showError ERROR_MESSAGES.PROFILES
          .finally () ->
            view.loading = false

        @$onInit = ->
          init()

        view
    ]
    link: (scope, element, attributes, rjmUi) ->
      if rjmUi?
        scope.$watch "view.loading", () ->
          rjmUi.blockUi("google-analytics-profile-picker", scope.view.loading)

]
